var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUserOutline = function SvgUserOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.4 7.74a3.6 3.6 0 1 1 7.2 0 3.6 3.6 0 0 1-7.2 0m3.6-4.9a4.91 4.91 0 1 0 0 9.82 4.91 4.91 0 0 0 0-9.83Zm0 11.11a9.16 9.16 0 0 0-8.72 6.36.65.65 0 0 0 .62.86h16.2a.65.65 0 0 0 .62-.86A9.15 9.15 0 0 0 12 13.95m-4.62 2.82a7.85 7.85 0 0 1 11.76 3.09H4.86a7.84 7.84 0 0 1 2.52-3.09",
    clipRule: "evenodd"
  })));
};
export { SvgUserOutline as ReactComponent };
export default __webpack_public_path__ + "static/media/userOutline.968bb43eb46578b48858361d2ab568cd.svg";